module.exports = __webpack_public_path__ + "img/image2.b8f93d2c.png";